module.exports = __webpack_public_path__ + "img/魏徽.303b364d.jpg";